export const css = {
    microViewWrapper: '_3z-TtMMG',
    microView: '_2Zj2yh_h',
    titleBlock: '_3h78jRYD',
    ' _key': 'afcpe-theme/afcpe/micro/quiz-widgets/quizfolder'
};
export default css;
